import { APIProvider } from "@vis.gl/react-google-maps";
import type { FC } from "react";
import { MAPS_API_KEY, MAPS_LIBRARIES } from "../../misc/googleMaps";
import type { AdminCustomerListItem } from "../customersApi";
import { useCustomers } from "../useCustomers";
import CustomerMap from "./CustomerMap";

const CustomerMapPage: FC = () => {
  const { customers } = useCustomers();
  // This page renders under /customers (ADMIN/AGENT only) — see AdminCustomerListItem in customersApi.ts for why
  // the staff-only fields are guaranteed to be present.
  return (
    <APIProvider apiKey={MAPS_API_KEY} libraries={MAPS_LIBRARIES}>
      <CustomerMap customers={customers as AdminCustomerListItem[]} />
    </APIProvider>
  );
};

export default CustomerMapPage;
